import { storage } from '~/common/utils/storage';
import { MessageBox, Message } from 'element-ui';
import { getUrl } from '~/common/utils/reduplicateMethods';
import {translateI18n} from '~/common/utils/i18n-helper'
export function round(number, precision) {//小数四舍五入
  return Math.round(+number + "e" + precision) / Math.pow(10, precision);
}

export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

/** 压缩文件
 * quality压缩百分比 0.3
 */
export function compressImage(file, quality, callback) {
  // quality 设置为0.3
  quality = quality || 0.3;
  const reader = new FileReader();
  reader.onload = function(event) {
    var result = event.target.result;
    if (file.size > 204800 && file.type !== 'image/gif' && quality < 1) {
      // 大于200Kb
      const img = new Image();
      img.src = result;
      img.onload = function() {
        // 如果图片大于四百万像素，计算压缩比并将大小压至400万以下
        var width = img.width;
        var height = img.height;

        var ratio;
        if ((ratio = (width * height) / 4000000) > 1) {
          ratio = Math.sqrt(ratio);
          width /= ratio;
          height /= ratio;
        } else {
          ratio = 1;
        }
        var canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        // 铺底色
        var ctx = canvas.getContext('2d');
        ctx.fillStyle = '#fff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        // 如果图片像素大于100万则使用瓦片绘制
        var count;
        if ((count = (width * height) / 1000000) > 1) {
          count = ~~(Math.sqrt(count) + 1);
          // 计算要分成多少块瓦片
          // 计算每块瓦片的宽和高
          var nw = ~~(width / count);
          var nh = ~~(height / count);
          var tCanvas = document.createElement('canvas');
          tCanvas.width = nw;
          tCanvas.height = nh;
          for (var i = 0; i < count; i++) {
            for (var j = 0; j < count; j++) {
              var tctx = tCanvas.getContext('2d');
              tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);

              ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
            }
          }
          tCanvas.width = tCanvas.height = 0;
        } else {
          ctx.drawImage(img, 0, 0, width, height);
        }
        // 进行最小压缩
        var ndata = canvas.toDataURL('image/jpeg', quality);
        canvas.width = canvas.height = 0;
        callback(ndata);
      };
    } else {
      // 小于200K不需要压缩 直接返回
      callback(result);
    }
  };
  reader.readAsDataURL(file);
}

/** 根据date URL 创建blob 用于上传 */
export function createBlob(result) {
  var arr = result.split(',');
  var mime = arr[0].match(/:(.*?)/)[1];
  var bstr = atob(arr[1]);
  var n = bstr.length;
  var u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], {
    type: mime
  });
}

/** 获取file大小的名称 */
export function fileSize(size) {
  var size_int = size;
  if (typeof size === 'string' && size.constructor == String) {
    size_int = parseInt(size);
  }
  var formatSize;
  if (parseInt(size_int / 1024 / 1024) > 0) {
    formatSize = (size_int / 1024 / 1024).toFixed(2) + 'MB';
  } else if (parseInt(size_int / 1024) > 0) {
    formatSize = (size_int / 1024).toFixed(2) + 'kB';
  } else {
    formatSize = size_int + 'Byte';
  }
  return formatSize;
}

/** 获取最大 z-index 的值 */
import { PopupManager } from 'element-ui/lib/utils/popup';
export function getMaxIndex() {
  return PopupManager.nextZIndex();
}

/** 深拷贝 */
export function objDeepCopy(source) {
  if (typeof source === 'object') {
    var sourceCopy = source instanceof Array ? [] : {};
    for (var item in source) {
      if (!source[item]) {
        sourceCopy[item] = source[item];
      } else {
        sourceCopy[item] = typeof source[item] === 'object' ? objDeepCopy(source[item]) : source[item];
      }
    }
    return sourceCopy;
  }
  return source;
}
/*对象深度合并*/
function isObj(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

let hasOwnProperty = Object.prototype.hasOwnProperty;
let propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Cannot convert undefined or null to object');
  }

  return Object(val);
}

function assignKey(to, from, key) {
  var val = from[key];

  if (val === undefined || val === null) {
    return;
  }

  if (Object.prototype.hasOwnProperty.call(to, key)) {
    if (to[key] === undefined || to[key] === null) {
      throw new TypeError('Cannot convert undefined or null to object (' + key + ')');
    }
  }

  if (!Object.prototype.hasOwnProperty.call(to, key) || !isObj(val)) {
    to[key] = val;
  } else {
    to[key] = assign(Object(to[key]), from[key]);
  }
}

function assign(to, from) {
  if (to === from) {
    return to;
  }

  from = Object(from);
  for (var key in from) {
    if (Object.prototype.hasOwnProperty.call(from, key)) {
      assignKey(to, from, key);
    }
  }

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(from);

    for (var i = 0; i < symbols.length; i++) {
      if (propIsEnumerable.call(from, symbols[i])) {
        assignKey(to, from, symbols[i]);
      }
    }
  }

  return to;
}

export function deepAssign(target) {
  target = toObject(target);

  for (var s = 1; s < arguments.length; s++) {
    assign(target, arguments[s]);
  }

  return target;
}

/**
 * 时间操作
 * @param
 */
/** 时间戳转date*/
import moment from 'moment';
import 'moment/locale/zh-cn';

export function getDateFromTimestamp(time) {
  var times = 0;
  if (time.length === 13) {
    times = parseInt(time);
  } else {
    times = parseInt(time) * 1000;
  }
  return new Date(times); // 如果date为13位不需要乘1000
}

/**
 *
 * @param {*} timestamp 时间戳
 * @param {*} format 格式化
 */
export function timestampToFormatTime(time, format) {
  // 接口返回时间戳之前，先做兼容2020-09-09 09:19:00
  if (time && time.length === 19) {
    return moment(time).format(format);
  } else if (time && time.toString().length === 10) {
    return moment(getDateFromTimestamp(time.toString())).format(format);
  } else if (time && time.toString().length > 10) {
    //time必须是数字，否则会显示无效时间
    return moment(+time).format(format);
  }
  return '';
}
/**
 * 获取某天凌晨00:00:00时的13位时间戳
 * @param {*} date 时间
 */
export function getZeroTime(date) {
  const thatDate = new Date(date);
  const year = thatDate.getFullYear();
  const month = thatDate.getMonth() + 1;
  const day = thatDate.getDate();
  return new Date(`${year}/${month}/${day} 00:00:00`).getTime();
}
/**
 *
 * @param {*} format 格式化字符串
 */
export function formatTimeToTimestamp(format) {
  if (format && format.length > 0) {
    var timeValue = moment(format)
      .valueOf()
      .toString();
    return timeValue.length > 10 ? timeValue.substr(0, 10) : timeValue;
  }
  return '';
}
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'object') {
    date = time;
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000;
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
}
export function formatTime(time, option) {
  const d = new Date(time).getTime();
  const now = Date.now();
  const diff = (now - d) / 1000;

  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    // less 1 day
    return timestampToFormatTime(time, "HH:mm");
  } else if (diff < 3600 * 24 * 2) {
    // less 2 day
    return '昨天';
  }
  if (option) {
    return timestampToFormatTime(time, option);
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
  }
}
export function distanceTime(start,end){
  if(!start || !end) return null
  if(String(start).length===10){
    start=parseInt(start)*1000
  }
  if(String(end).length===10){
    end=parseInt(end)*1000
  }
  // 计算时间差（以毫秒为单位）
  const timeDiff = end - start;
  // 将时间差转换为小时、分钟和秒数
  const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
  const hours = Math.floor(timeDiff / (1000 * 60 * 60) % 24);
  const minutes = Math.floor((timeDiff / (1000 * 60)) % 60);
  const seconds = Math.floor((timeDiff / 1000) % 60);
  const ret=`${days} 天 ${hours} 小时 ${minutes} 分  ${seconds} 秒`
  return {days,hours,minutes,seconds,ret};
}
/**
 *
 * @param {*} len 随机字符串长度
 */
export function randomString(len) {
  len = len || 6;
  var $chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var str = '';
  for (let i = 0; i < len; i++) {
    str += $chars.charAt(Math.floor(Math.random() * $chars.length));
  }
  return str;
}

/**
 * *
 * @param {*} obj 对象
 * @param {*} arr 要删除的字段
 */
export function deleteObjectItem(obj, arr) {
  arr.forEach(item => {
    delete obj[item];
  });
}

/** image 下载 */
/**
 *
 * @param {*} data url
 * @param {*} filename 名称
 */
export function downloadImage(data, filename) {
  var httpindex = data.indexOf('http');
  if (httpindex === 0) {
    const image = new Image();
    // 解决跨域 canvas 污染问题
    image.setAttribute('crossOrigin', 'anonymous');
    image.onload = function() {
      const canvas = document.createElement('canvas');
      canvas.width = image.width;
      canvas.height = image.height;
      const context = canvas.getContext('2d');
      context.drawImage(image, 0, 0, image.width, image.height);
      const dataURL = canvas.toDataURL('image/png');
      // 生成一个 a 标签
      const a = document.createElement('a');
      // 创建一个点击事件
      const event = new MouseEvent('click');
      // 将 a 的 download 属性设置为我们想要下载的图片的名称，若 name 不存在则使用'图片'作为默认名称
      a.download = filename || '图片';
      // 将生成的 URL 设置为 a.href 属性
      var blob = dataURLtoBlob(dataURL);
      a.href = URL.createObjectURL(blob);
      // 触发 a 的点击事件
      a.dispatchEvent(event);
    };
    image.src = data;
  } else {
    // 生成一个 a 标签
    const a = document.createElement('a');
    // 创建一个点击事件
    const event = new MouseEvent('click');
    // 将 a 的 download 属性设置为我们想要下载的图片的名称，若 name 不存在则使用'图片'作为默认名称
    a.download = filename || '图片';
    // 将生成的 URL 设置为 a.href 属性
    a.href = data;
    // 触发 a 的点击事件
    a.dispatchEvent(event);
  }
}
/**
 * path  和 name
 */
export function downloadFile(data) {
  var a = document.createElement('a');
  a.href = data.path;
  a.download = data.name ? data.name : translateI18n('portal.wen-jian');
  a.target = '_black';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
/* ipfs【下载文件】
 ** 使用说明：新的下载文件方法，兼容华为云上传后的视频文件
 ** 参数说明：
 ** file: {  // 文件对象[必须]
 **   file_name: '今日说法.doc'
 **   ipfs: '5435353521sdffasdasa'
 ** }
 */
export const ifpsDownloadFile = file => {
  if (!file?.ipfs) return;
  const fileUrl = file.ipfs.startsWith('http') ? file.ipfs : `/rest/store/general/v3/image/${file.ipfs}`;
  const elink = document.createElement('a');
  elink.download = file.file_name;
  elink.target = '_blank';
  elink.style.display = 'none';
  elink.href = fileUrl;
  document.body.appendChild(elink);
  elink.click();
  document.body.removeChild(elink);
};

export function dataURLtoBlob(dataurl) {
  // eslint-disable-next-line one-var
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], {
    type: mime
  });
}

export function getBase64Image(img) {
  var canvas = document.createElement('canvas');
  canvas.width = img.width;
  canvas.height = img.height;
  var ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0, img.width, img.height);
  var ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase();
  var dataURL = canvas.toDataURL('image/' + ext);
  return dataURL;
}

// 获取绑定参数
export function guid() {
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  return S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4();
}

/**
 * 金额格式化 增加千分符
 * @param {*} val
 */
export function moneyFormat(val) {
  if (!val) return '0.00';
  const i = Math.floor(val);
  const d = val.split('.')[1] || '00';
  return i.toLocaleString('en-US') + '.' + d;
}

/**
 * 下载excel
 */
export function downloadExcelWithResData(res) {
  let fileName = res.headers['content-disposition'].split('filename=')[1];
  if (!fileName) {
    fileName = res.headers['content-disposition'].split("UTF-8''")[1];
  }
  fileName = fileName ? fileName.replace(/\"/g, '') : 'file.xlsx';
  fileName = decodeURI(fileName) || '';
  downloadFileWithBuffer(res.data, fileName, 'application/vnd.ms-excel;charset=utf-8');
}

export function downloadFileWithBuffer(data, name, type) {
  var blob = new Blob([data], {
    type: type || ''
  });
  var downloadElement = document.createElement('a');
  var href = window.URL.createObjectURL(blob); // 创建下载的链接
  downloadElement.href = href;
  downloadElement.download = name; // 下载后文件名
  document.body.appendChild(downloadElement);
  downloadElement.click(); // 点击下载
  document.body.removeChild(downloadElement); // 下载完成移除元素
  window.URL.revokeObjectURL(href); // 释放掉blob对象
}
/**
 * 表格字段格式化
 * @param element
 */
export function tableFieldFormatter(element, obj) {
  let rules = {};
  /** 获取需要格式化的字段 和格式化的规则 */
  switch (element.form_type) {
    case 'date':
      rules[element.fieldName] = {
        formatter: function fieldFormatter(time) {
          if (time == '0000-00-00') {
            time = '';
          }
          return moment(getDateFromTimestamp(time)).format('YY-MM-DD');
        }
      };
      break;
    case 'datetime':
      rules[element.fieldName] = {
        formatter: function fieldFormatter(time) {
          if (time == 0 || !time) {
            return '';
          }
          return moment(getDateFromTimestamp(time)).format('YY-MM-DD HH:mm:ss');
        }
      };
      break;
    case 'obj':
      rules[element.fieldName] = {
        formatter: function fieldFormatter(info) {
          return info ? info.name : '';
        }
      };
      break;
    case 'structure':
      rules[element.fieldName] = {
        formatter: function fieldFormatter(info) {
          if (info) {
            var content = '';
            for (let index = 0; index < info.length; index++) {
              const element = info[index];
              content = content + element.name + (index === info.length - 1 ? '' : ',');
            }
            return content;
          }
          return '';
        }
      };
      break;
    case 'floatnumber':
      rules[element.fieldName] = {
        type: 'floatnumber',
        formatter: function fieldFormatter(info) {
          return moneyFormat(info);
        }
      };
      break;
    case 'type_obj':
      rules[element.fieldName] = {
        type: 'type_obj',
        formatter: function fieldFormatter(info) {
          return obj[info];
        }
      };
      break;
  }
  return rules;
}

/**
 * 修改例如 baseInfo.option.field数据结构
 * 根据数组生成对象，用于避免页面上多次循环赋值，例如：赋值select的option
 * @params arr
 * @callback json
 */
export function changeData(arr, target) {
  if (!Array.isArray(arr)) return arr;
  const json = {};
  const name = target ? target : 'name';
  arr.map((item, k) => {
    if (!json[item[name]]) {
      json[item[name]] = {};
      json[item[name]].index = k;
    }
  });
  return json;
}

export function isDef(v) {
  return v !== undefined && v !== null;
}
export function isUndef(v) {
  return v === undefined || v === null;
}
/**
 * @params data  输入数据 要求输入字符串 因为数字00,0.00都会被处理成0
 * @params flag  正负判断 '-' '+' 或不填
 * @params decimals 小数位数
 * 除了第一个参数外，其余可以缺省输入，第二位传入数字会直接校验小数位数
 * */
export function numberDecimals(data, flag, decimals) {
  if (typeof data !== 'string') {
    return { error: false, msg: '请输入负数' };
  }
  //首先判断是不是数字
  if (isNaN(data)) return { error: false, msg: '请输入数字' };
  //需要符合3种条件
  const reg1 = /^-?0\.[0-9]+$/;
  const reg2 = /^-?[1-9][0-9]*\.[0-9]+$/;
  const reg3 = /^-?[1-9][0-9]*$/;
  const reg4 = /^0$/;
  if (!reg1.test(data) && !reg2.test(data) && !reg3.test(data) && !reg4.test(data)) {
    return {
      error: false,
      msg: '请输入合法的数字'
    };
  }
  if (arguments.length === 1) {
    //只是判断是数字或小数
    return { error: true };
  } else if (arguments.length === 2) {
    const n1 = arguments[1];
    if (typeof n1 === 'string') {
      //正负判断
      const a1 = n1 === '-' && Number(data) < 0 ? { error: true } : { error: false, msg: '请输入负数' };
      const a2 = n1 === '+' && Number(data) > 0 ? { error: true } : { error: false, msg: '请输入正数' };
      return a1 || a2;
    } else if (typeof n1 === 'number') {
      //小数位
      const m = `${data}`.split('.')[1] ? `${data}`.split('.')[1] : '';
      return `${m}`.length <= n1 ? { error: true } : { error: false, msg: `最多${n1}位小数` };
    }
  } else if (arguments.length === 3) {
    const n1 = arguments[1];
    const n2 = arguments[2];
    const a1 = n1 === '-' && Number(data) < 0 ? { error: true } : { error: false, msg: '请输入负数' };
    const a2 = n1 === '+' && Number(data) > 0 ? { error: true } : { error: false, msg: '请输入正数' };
    const m = `${data}`.split('.')[1] ? `${data}`.split('.')[1] : '';
    const a3 = `${m}`.length <= n2 ? { error: true } : { error: false, msg: `最多${n2}位小数` };
    return (a1 || a2) && a3;
  }
}
/**
 * 乘法
 * 避免浮点数精度问题，比如0.012345 * 0.000001 = 1.2345e-8 ；直接相乘 = 1.2344999999999999e-8
 * @param {number||string} a1
 * @param {number||string} a2
 * @returns
 */
export function multiplication(a1, a2) {
  a1 = a1 ? a1 : 0
  a2 = a2 ? a2 : 0
  const arr1 = `${a1}`.split('.');
  const arr2 = `${a2}`.split('.');
  //获取小数位数
  const decimal1 = arr1[1] ? arr1[1].length : 0;
  const decimal2 = arr2[1] ? arr2[1].length : 0;
  //小数位综合
  const decimalLength = +decimal1 + +decimal2;

  //去除小数点，这里不能通过乘法去处理
  const pow1 = `${a1}`.replace('.', '');
  const pow2 = `${a2}`.replace('.', '');

  const result = (pow1 * pow2) / Math.pow(10, decimalLength);
  return result;
}
//加法
export function add(arg1, arg2) {
  arg1 = arg1.toString()
  arg2 = arg2.toString();
  const arg1Arr = arg1.split(".")
  const arg2Arr = arg2.split(".")
  const d1 = arg1Arr.length == 2 ? arg1Arr[1]: ""
  const d2 = arg2Arr.length == 2 ? arg2Arr[1] : "";
  const maxLen = Math.max(d1.length, d2.length);
  const m = Math.pow(10, maxLen);
  const result = Number(((arg1 * m + arg2 * m) / m).toFixed(maxLen));
  const d = arguments[2];
  return typeof d === "number" ? Number((result).toFixed(d)) : result;
}
//减法
export function sub(arg1, arg2) {
  return add(arg1, -Number(arg2), arguments[2]);
}
//除法
export function divi(arg1, arg2) {
  const r1 = arg1.toString()
  const r2 = arg2.toString()
  let m
  let resultVal
  m = (r2.split(".")[1] ? r2.split(".")[1].length : 0) - (r1.split(".")[1] ? r1.split(".")[1].length : 0);
  resultVal = Number(r1.replace(".", "")) / Number(r2.replace(".", "")) * Math.pow(10, m);
  return  Number(resultVal)
}

//四舍五入
export function myFixed(num, digit) {
  num = parseFloat(num);
  return (Math.round((num + Number.EPSILON) * Math.pow(10, digit)) / Math.pow(10, digit)).toFixed(digit);
}
//小数位截取，还是四舍五入
export function decimalDeal(value, {type, decimal}) {
  let v = value
  if(type === 'cut') {
    let [int, deci] = `${v}`.split('.')
    if(deci && `${deci}`.length > decimal) {
      deci = `${deci}`.substring(0,decimal)
      v = `${int}.${deci}`
    }
  } else if(type === 'fixed') {
    v = myFixed(v, decimal)
  } else {
    return v
  }
  return v
}
export function approveTip(doTip = true) {
  if (process.client) {
    let profile = storage.get('profile');
    let pending = profile.latest_account_pending;
    if (!pending) {
      // doTip && MessageBox.alert("账户不存在，请建账", "提示", {
      //   confirmButtonText: "确定",
      //   type: "warning",
      // });
      doTip && Message.warning(`账户不存在，请建账`);
      return false;
    }
    if (pending === '提交' || pending === '商户批准') {
      // doTip && MessageBox.alert(`账户审批中，请完成后操作`, "提示", {
      //   confirmButtonText: "确定",
      //   type: "warning",
      // });
      doTip && Message.warning(`账户审批中，请完成后操作`);
      return false;
    }
    return true;
  }
}

export function debounce(func, wait = 100, immediate = false) {
  // 防抖
  let timer;
  return (...args) => {
    let context = this;
    if (timer) clearTimeout(timer);
    if (immediate) {
      let callNow = !timer;
      timer = setTimeout(() => {
        timer = null;
      }, wait);
      if (callNow) func.apply(context, args);
    } else {
      timer = setTimeout(() => {
        func.apply(context, args);
      }, wait);
    }
  };
}

// 从cookie中获取sessionToken
export const getSessionToken = cookie => {
  let sessionToken = '';
  if (!cookie) return sessionToken;
  const arrCookie = cookie.split(';');
  const authTag = 'auth=';
  try {
    arrCookie.forEach(item => {
      if (item.includes(authTag)) {
        sessionToken = JSON.parse(decodeURIComponent(item).trim().replace(authTag, '')).accessSession;
      }
    });
  } catch (err) {}
  return sessionToken;
};

// 从cookie中获取当前栏目详情
export const getColumnDetail = cookie => {
  let columnDetail = { column_id: '', shop_id: '', name: '' };
  if (!cookie) return columnDetail;
  const arrCookie = cookie.split(';');
  const columnTag = 'columnDetail=';
  try {
    arrCookie.forEach(item => {
      if (item.includes(columnTag)) {
        columnDetail = JSON.parse(item.trim().replace(columnTag, ''));
      }
    });
  } catch (err) {}
  return columnDetail;
};

export function getSegment() {
  // 排期获取对应时间段 返回对应的值
  let curHours = new Date().getHours();
  let segment = 1;
  if (curHours >= 0 && curHours < 2) {
    segment = 1;
  } else if (curHours >= 2 && curHours < 4) {
    segment = 2;
  } else if (curHours >= 4 && curHours < 6) {
    segment = 3;
  } else if (curHours >= 6 && curHours < 8) {
    segment = 4;
  } else if (curHours >= 8 && curHours < 10) {
    segment = 5;
  } else if (curHours >= 10 && curHours < 12) {
    segment = 6;
  } else if (curHours >= 12 && curHours < 14) {
    segment = 7;
  } else if (curHours >= 14 && curHours < 16) {
    segment = 8;
  } else if (curHours >= 16 && curHours < 18) {
    segment = 9;
  } else if (curHours >= 18 && curHours < 20) {
    segment = 10;
  } else if (curHours >= 20 && curHours < 22) {
    segment = 11;
  } else if (curHours >= 22 && curHours < 24) {
    segment = 12;
  }
  return segment;
}

// 获取头部session。从ic-utils中挪到utils中，因为utils是所有项目公用的
export function getHttpHeader() {
  let session = '';
  if (process.client) {
    session = storage.get('session_token') || storage.get('session_token', true) || '';
  }
  return session;
}

// 判断是mob端还是pc端
export function checkPlatformType(userAgent = '') {
  const agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPod', 'iPad'];
  return agents.some(item => userAgent.includes(item)) ? 'mob' : 'pc';
}

// 判断是否是常用浏览器（谷歌浏览器且版本高于67、火狐、Edge、safari）
export function isCommonBrowser() {
  if (process.server) return false;
  const userAgent = navigator.userAgent.toLowerCase();
  if ((userAgent.match(/chrome\/[\d.]+/gi) + '').replace(/[^0-9.]/gi, '').split('.')[0] >= 67) {
    return true;
  }
  if (navigator.userAgent.indexOf('edg') > -1 || userAgent.indexOf('firefox') > -1 || userAgent.indexOf('safari') > -1) {
    return true;
  }
  return false;
}

// 判断某个元素是否在可视区域
export function isElementNotInViewport(el) {
  let rect = el.getBoundingClientRect();
  return rect.top >= (window.innerHeight || document.documentElement.clientHeight) || rect.bottom <= 0;
}

/**
 * 功能：获取文件类型图标
 * 参数：file（文件数据）、type（文件类型）
 * 返回：文件引用地址
 * */
export function funGetFileTypeIcon(file, type) {
  if (file?.ipfs?.startsWith('http')) {
    return file.ipfs;
  }
  let index = file.file_name.lastIndexOf('.');
  let ext = file.file_name.substr(index + 1).toLowerCase();
  const arrayContain = (array, string) => {
    return array.some(item => {
      return item === string;
    });
  };
  if (arrayContain(['jpg', 'jpeg', 'png', 'gif', 'raw'], ext)) {
    if (type == 'm') {
      return '/rest/store/general/v3/image/' + file.ipfs;
    } else {
      return require(`~/common/assets/img/file_img_${type}.png`);
    }
  } else if (arrayContain(['mp4', 'mp3', 'avi'], ext)) {
    return require(`~/common/assets/img/file_video_${type}.png`);
  } else if (arrayContain(['xlsx', 'xls'], ext)) {
    return require(`~/common/assets/img/file_excle_${type}.png`);
  } else if (arrayContain(['doc', 'docx'], ext)) {
    return require(`~/common/assets/img/file_word_${type}.png`);
  } else if (arrayContain(['rar', 'zip'], ext)) {
    return require(`~/common/assets/img/file_zip_${type}.png`);
  } else if (ext === 'pdf') {
    return require(`~/common/assets/img/file_pdf_${type}.png`);
  } else if (ext === 'ppt' || ext === 'pptx') {
    return require(`~/common/assets/img/file_ppt_${type}.png`);
  } else if (arrayContain(['txt', 'text'], ext)) {
    return require('~/common/assets/img/file_txt_m.png');
  }
  return require(`~/common/assets/img/file_unknown_${type}.png`);
}

/**
 * 功能：内容展示页分屏插入广告
 * 参数：boxDom(需要插入广告的外层dom)、adList(广告数组)、columnLayoutId(广告所属的栏目的id)、bannerSize(广告banner图尺寸枚举)
 * 参数：clickCallback(点击广告事件回调)、viewCallback(看到广告事件回调)
 * 备注：内部用到了jq操作dom方法
 * 返回：无
 * */
export const insertAdvertisement = ({ boxDom, adList, columnLayoutId, bannerSize, clickCallback, viewCallback }) => {
  if (!boxDom || process.server) return;
  const boxJqDom = $(boxDom);
  let tryNum = 0;
  let tryTimeout = null;
  // 广告点击事件做下代理，被点击时做埋点统计
  boxJqDom.on('click', '.display-page-ad', event => {
    const scheduleId = event.target?.dataset?.id;
    if (!scheduleId) return false;
    const adItem = adList.filter(item => item.schedule_id === scheduleId)[0];
    if (typeof clickCallback === 'function' && adItem) {
      clickCallback(adItem);
    }
  });
  // 广告被看到时的事件处理，用观察者模式监听，被看到时埋点统计
  const observerAdImage = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach(entrie => {
        const adDom = entrie.target;
        const scheduleId = adDom.dataset?.id;
        const adItem = adList.filter(item => item.schedule_id === scheduleId)[0];
        if (typeof viewCallback === 'function' && adItem && entrie.isIntersecting) {
          viewCallback(adItem);
          observer.unobserve(adDom);
        }
      });
    },
    { threshold: 0.1 }
  );

  // 因为文章dom渲染有延迟，所以声明一个函数，5秒内循环20次，超过之后就不再执行。主要是用来检测文章内容是否渲染出来以及广告数据是否存在
  const funInsert = () => {
    const boxChilds = boxJqDom.children();
    if ((boxChilds.length === 0 || adList.length === 0) && tryNum < 20) {
      tryTimeout = setTimeout(() => {
        tryNum++;
        funInsert();
      }, 250);
      return;
    }
    clearTimeout(tryTimeout);
    tryTimeout = null;
    // 检测到渲染后，遍历文章dom的每一个子节点，找到能适合插入的子节点。这里需要通过广告所在的栏目计算出这个广告应有的高度
    // 插入原则为：1.一屏插入一个广告，且插入在这一屏最下方能被看见的dom节点前面 2.查找这个dom节点时要考虑图片已被插进去的高度
    let arrInsertDom = [];
    const marginNum = 10;
    const bannerSizePer = bannerSize[columnLayoutId][0] / bannerSize[columnLayoutId][1];
    const bannerHeight = Math.round((boxJqDom.width() || 652) / bannerSizePer);
    const viewHeight = window.innerHeight || 960;
    [...boxChilds].forEach(childDom => {
      const $childDom = $(childDom);
      if ($childDom.offset().top + $childDom.outerHeight(true) + (arrInsertDom.length + 1) * (bannerHeight + marginNum * 2) >= viewHeight * (arrInsertDom.length + 1)) {
        arrInsertDom.push($childDom);
      }
    });
    // 如果广告数量不够多，需要循环插入。如果广告数量太少，则选择前面的插入，后面的放弃
    let lastAdList = [...adList];
    if (adList.length < arrInsertDom.length) {
      const copyNum = Math.floor(arrInsertDom.length / adList.length);
      for (let i = 0; i < copyNum; i++) {
        lastAdList.push(...adList);
      }
    }
    // 获取图片地址
    const getImgUrl = adItem => {
      let fileData;
      if (adItem.ipfs) {
        //自己额外上传的图
        fileData = { file_name: adItem.file_name, ipfs: adItem.ipfs };
      } else {
        fileData = adItem.thumbnail_array && adItem.thumbnail_array.length > 0 ? adItem.thumbnail_array[0] : { file_name: 'file_txt_m', ipfs: '' };
      }
      return funGetFileTypeIcon(fileData, 'm');
    };
    // 根据查找到的dom节点，在每个节点前插入图片广告dom
    arrInsertDom.forEach((domItem, index) => {
      const adItem = lastAdList[index];
      let htmlDom = `<p style="position:relative; margin: ${marginNum}px 0; cursor:pointer;">`;
      htmlDom += '<span style="position:absolute; left:10px; bottom:10px; padding:2px 4px; font-size:12px; color:@icColor; border-radius: 4px; background: rgba(223, 223, 223, 0.8);">广告</span>';
      htmlDom += `<a href="${getUrl(adItem)}" target="_blank"><img class="display-page-ad" style="display:block; width:100%; height:${bannerHeight}px;" data-id="${
        adItem.schedule_id
      }" src="${getImgUrl(adItem)}" alt="${adItem.name}"/></a>`;
      htmlDom += '</p>';
      domItem.before(htmlDom);
    });
    // 插入完毕后，监听广告dom
    const arrAdImage = boxJqDom.find('.display-page-ad');
    [...arrAdImage].forEach(adItem => {
      observerAdImage.observe(adItem);
    });
  };
  funInsert();
};

/**
 * 功能：统一处理表格状态显示（阶段+消息数+是否启用）
 *
 * 最后更新：2022-08-22 黄金龙
 * 更新说明：由于第三个字段差异太大，所有由boolean类型改为string类型，并提前做好判断显示
 *
 * 参数：(
 *   rowData: {XXX} // 表格行数据[必须]
 *   columnItem: {  // 表头column数据[必须]
 *     domain: 'content', // 表格所属领域[必须]，可在表头option的head中定义
 *     xxx: '',  // 其他表头数据[非必须]，有需要做特殊处理的可以传进来
 *   }
 * )
 *
 * 说明：由于各域返回的数据结构可能不统一，所以通过domain参数来进行判断并在switch中自行拓展，将stateData赋值，最终格式应为：
 * stateData: {
 *   code: String, // 阶段简写码，L:初始 E:联系 A:交付 D:完成
 *   name: String, // 阶段中文名，L:初始 E:联系 A:交付 D:完成
 *   msg: Number,  // 消息数量
 *   active: String, // 启用状态，Y:是 N:否 其他特殊名称可自行拓展
 * }
 *
 * 返回：最终返回dom结构，给baseTable渲染
 * */
export const commonState = (rowData = {}, columnItem = {}) => {
  // 1. 先声明初始状态code、name、msg、active，以及其他变量
  let stateData = { code: 'L', name: '初始', msg: 0, active: 'Y' };
  let stageObj = {
    L: { code: 'L', name: '初始' },
    E: { code: 'E', name: '联系' },
    A: { code: 'A', name: '交付' },
    D: { code: 'D', name: '完成' },
    N: { code: '--', name: '--' }
  };
  let popTitle = { first: '阶段', second: '消息', third: '启用' }; //指定冒泡名
  const popVal = { first: stateData.name, second: stateData.msg, third: stateData.active }; //指定冒泡取值
  stateData = { ...stateData, popTitle: popTitle, popVal: popVal };
  const booleanToText = boolean => {
    if (typeof boolean === 'undefined') return 'Y';
    return !!boolean ? 'Y' : 'N';
  };
  const stateField = rowData.state || rowData.status || 'N';
  const matchStage = stageObj[stateField] || { code: '--', name: '--' };
  // 2. 在这里对不同的域进行判断和拓展，主要为改造stateData中的四个字段
  switch (columnItem.domain) {
    // 内容域
    case 'content':
      const findStage = Object.values(stageObj).find(item => item.name === rowData.state_name) || stageObj.N;
      Object.assign(stateData, {
        code: findStage.code,
        name: findStage.name,
        msg: rowData.msg_count || 0,
        active: typeof rowData.active === undefined ? booleanToText(rowData.enable) : booleanToText(rowData.active)
      });
      Object.assign(stateData, { popVal: { first: stateData.name, second: stateData.msg || 0, third: stateData.active } });
      break;
    // 合约域
    case 'contract':
      stageObj = {
        default: { L: [10], E: [20, 40], A: [30], D: [50, 60, 70] }, // 配额项、等级、任务、激励、套餐、模板
        hubs: { L: [10], E: [20, 30], A: [40, 50], D: [60, 70, 71, 72] }, // 签约列表
        hubsTask: { L: [10], E: [20], A: [40], D: [30] }, // 签约任务
        hubsIncentive: { L: [10], E: [20, 30], A: [40], D: [50] }, // 签约激励
        origin: { L: ['L'], E: ['E'], A: ['A'], D: ['D'] } //芯之元后端返回阶段state为LEAD
      };
      Object.entries(stageObj).forEach(item => {
        if (item[0] === columnItem.columnType) {
          Object.entries(item[1]).forEach(im => {
            if (im[1].includes(rowData.state)) {
              Object.assign(stateData, { code: im[0] });
            }
          });
        }
      });
      Object.assign(stateData, {
        name: rowData.state_name || stateData.code,
        msg: rowData.notify_count || 0,
        active: columnItem.id === 'active' ? booleanToText(rowData[columnItem.id]) : booleanToText(stateData.code !== 'D') //非激活/启用状态直接取状态值
      });
      Object.assign(stateData, { popVal: { first: stateData.name, second: stateData.msg || 0, third: stateData.active } });
      break;
    //qa域
    case 'qa':
      Object.assign(stateData, { code: matchStage.code, name: matchStage.name, msg: rowData.notify_count || 0, popTitle: { ...popTitle, third: '发布' } });
      Object.assign(stateData, { popVal: { first: stateData.name, second: stateData.msg || 0, third: 'Y' } });
      break;
    // 公共域、qa域、产品域、订单域
    case 'common':
    case 'product':
    case 'order':
      Object.assign(stateData, { code: matchStage.code, name: matchStage.name, msg: rowData.notify_count || 0, active: booleanToText(rowData.active) });
      Object.assign(stateData, { popVal: { first: stateData.name, second: stateData.msg || 0, third: stateData.active } });
      break;
    // 供求域
    case 'biz':
      Object.assign(stateData, { code: matchStage.code, name: matchStage.name, msg: rowData.notify_count || 0 });
      /** 第三个字段 需要额外处理：
       * 询价供货：阶段+通知数+是否发布
       * 购销项：阶段+通知数+审批状态
       */
      const typeObj = {
        rfq_line: 'published',
        avab_line: 'published',
        qfr_line: 'active',
        qfa_line: 'active',
        sales_order_line: 'order_status',
        purchase_order_line: 'order_status',
        sales_order_list: 'approved_status',
        purchase_order_list: 'approved_status',
        rfq_list: 'active',
        avab_list: 'active',
        qfr_list: 'active',
        qfa_list: 'active'
      };
      const popType = {
        //冒泡标题
        published: '发布',
        active: '启用',
        order_status: '审批',
        approved_status: '审批'
      };
      const popThirdVal = { P: '初始', S: '提交', A: '批准', C: '取消', R: '退回', Y: 'Y', N: 'N' }; //冒泡取值
      let name = typeObj[columnItem.path];
      if (columnItem.showEnd) {
        // 有showEnd字段则直接返回该字段
        Object.assign(stateData, { active: rowData[columnItem.showEnd] }, { popTitle: { ...popTitle, third: popType[name] } });
        break;
      }
      if (rowData.line_type) {
        name = typeObj[rowData.line_type];
      }
      let aValue = '';
      const isShowStatus = ['sales_order_line', 'purchase_order_line', 'sales_order_list', 'purchase_order_list'].includes(columnItem.path);
      const dataType = ['sales_order_line', 'purchase_order_line'].includes(rowData.line_type) ? 1 : 2;
      if (isShowStatus) {
        aValue = rowData[name];
      } else if (columnItem.path === 'biz_line') {
        aValue = dataType === 1 ? (rowData[name] !== undefined ? rowData[name] : '--') : booleanToText(rowData[name]);
      } else {
        aValue = booleanToText(rowData[name]);
      }
      Object.assign(stateData, { active: aValue }, { popTitle: { ...popTitle, third: popType[name] } });
      Object.assign(stateData, { popVal: { first: stateData.name, second: stateData.msg || 0, third: popThirdVal[aValue] || '--' } });
      break;
    // 账户域-账户管理
    case 'account':
      Object.assign(stateData, { code: matchStage.code, name: matchStage.name, msg: rowData.notify_count || 0, active: rowData.pending || '--' });
      Object.assign(stateData, { popVal: { first: stateData.name, second: stateData.msg || 0, third: stateData.active } });
      break;
    // 默认不做处理
    default:
      break;
  }
  // 3. 如果状态字段不存在，只返回阶段名称
  if (stateField === 'N') {
    return `<p class="common-state-box" title="阶段：${stateData.name}"><span class="common-state-code">${stateData.code}</span></p>`;
  }
  // 4. 下面再根据code、name、msg、active统一渲染dom
  let stateDom = ``;
  stateDom += `<p class="common-state-box" title="${stateData.popTitle.first}：${stateData.popVal.first}\n${stateData.popTitle.second}：${stateData.popVal.second}\n${stateData.popTitle.third}：${stateData.popVal.third}">`;
  stateDom += `<span class="common-state-code">${stateData.code}</span>`;
  stateDom += `<span class="common-state-msg" style="background-color: ${stateData.msg > 0 ? '#ea5728' : '#ccc'}">${stateData.msg}</span>`;
  stateDom += `<span class="common-state-active">${stateData.active}</span>`;
  stateDom += `</p>`;
  return stateDom;
};

/*
指定状态栏目三个值的字段
例如 state + 圈 + active  state + 圈 + 审批
这样不用区分域，并且就目前来说，这三个字段的代表值，可能都不一样
*/
// index.js和json.js存在循环调用，导致index中hasOwnProperty无法识别，暂时先提取到这里 2022-08-16 黄金龙
const approvalLetter = {
  draft: 'P',
  submit: 'S',
  return: 'R',
  cancel: 'C',
  confirm: 'A'
};
export const setStatus = (rowData = {}, fields = []) => {
  const [first, second, third] = fields;
  const showYN=['active','published','is_inactive','posted','order_canceled','invalid','is_assigned'];
  // 状态不返回，没有展示的意义，展示--
  if (rowData[first] === undefined || !rowData[first]) {
    return '<span class="tbl-state-name">--</span>';
  }
  // 声明stateData初始结构
  let dom = '';
  dom += `<span class="tbl-state-name">${rowData[first]}</span>`;
  dom += `<span class="msg ${!rowData[second] ? ' none' : ''}">${rowData[second] || 0}</span>`;
  if (showYN.includes(third)) {
    let currentState = rowData[third] ? 'Y' : 'N';
    if(typeof rowData[third] === "string"){
      currentState = rowData[third]
    }
    if (!rowData[third] && rowData[third] !== false) {
      currentState = '';
    }
    dom += `<span class="tbl-state-active">${currentState}</span>`;
  } else if (third === 'approval') {
    dom += `<span class="tbl-state-active">${approvalLetter[rowData[third]] || '-'}</span>`;
  } else {
    dom += `<span class="tbl-state-active">${rowData[third]}</span>`;
  }
  return dom;
};
export function curriedProcessor() {
  let priceSymbol = ''
  const steps = [];
  function addStep(fn, ...args) {
    steps.push({ fn, args });
    return processor;
  }
  function processor(input) {
    return steps.reduce((result, step) => {
      return step.fn(result, ...step.args);
    }, input);
  }
  processor.priceDecimal = function(currency_id) {
    const cid = !currency_id || currency_id === '0' ? '8' : currency_id
    const rest = storage.get('currency').find(v => cid == v.id)
    return addStep((price, currencyMs) => {
      const {decimals, symbol} = currencyMs
      priceSymbol = symbol
      return divi(price, Math.pow(10, decimals))
    }, rest);
  };
  processor.toThousands = function() {
    return addStep(num =>{
      let isNegative = num < 0;
      if(isNegative) {
        num = `${num}`.substring(1)
      }
      let [integerPart, decimalPart] = `${num}`.split('.');
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      let res = integerPart + (decimalPart ? '.' + decimalPart : '');
      // 如果原数是负数，添加负号
      if (isNegative) {
        res = '-' + res;
      }
      return res;
    });
  };
  processor.addPriceSymbol = function() {
    return addStep(price => {
      return `${priceSymbol}${price}`
    });
  };
  processor.roundUp = function(digit) {
    return addStep((num,cnt) => {
      let n = parseFloat(num);
      return (Math.round((n + Number.EPSILON) * Math.pow(10, cnt)) / Math.pow(10, cnt)).toFixed(cnt);
    }, digit);
  }
  processor.multiplication = function(n) {
    return addStep((num,cnt) => {
      return multiplication(num, cnt)
    }, n);
  }
  return processor;
}
export function isMobileDevice() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const isMobileUA = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
  const isSmallScreen = window.innerWidth <= 768
  return isMobileUA && isSmallScreen
}
